import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from "./Navbar";
import Footer from "./Footer";

const CancellationPolicy = () => {

    const navStyle = {
        backgroundColor: "#f0f0f0",
        padding: "12px 12px 12px 5%",
        borderRadius: "5px",
      };
    
    const ulStyle = {
        listStyleType: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        alignItems: "center",
        fontSize: "11px",
      };
    
      const liStyle = {
        marginRight: "6px",
      };
    
      const linkStyle = {
        textDecoration: "none",
        color: "#000",
        cursor:"pointer "
      };
    

  const headingStyle = {
    fontSize: "30px",
    margin:"0",    
  };

  const paragraphStyle = {
    lineHeight: "1.8",
    textAlign: "justify",
  };


  const containerStyle = {
    textAlign: "justify",
    gap: "20px",
    padding:"2% 5% 3% 5%",
    backgroundColor:"rgb(232, 240, 238)",   //rgb(230, 215, 184)
    color:"rgb(93, 64, 55)"
  };

      const navigate = useNavigate();
        const Home = () => {
          navigate("/")
        }



  const sectionHeadingStyle = {
    fontSize: '30px',
    marginTop: '40px',
  };

  return (
    <>
    <Navbar />
    <section>
      <nav style={navStyle}>
        <ul style={ulStyle}>
          <li style={liStyle}>
            <a onClick={Home} style={linkStyle}>HOME</a>
          </li>
          <li style={liStyle}>&gt;</li>
          <li>
            <a style={linkStyle}>CANCELLATION POLICY</a>
          </li>
        </ul>
      </nav>
    </section>
    <div className="qoffee-page" style={containerStyle} >
      <h1 style={headingStyle}>CANCELLATION POLICY</h1>

      <div className="qoffee-page-container" >
        <p style={paragraphStyle}>
          This Cancellation Policy (“Policy”) governs the terms under which customers (“You” or “Customer”) may request
          the cancellation of orders placed through Magic Roast Qoffee (“Company,” “We,” “Us,” or “Our”). By placing an
          order on our website, you agree to be bound by this Policy.
        </p>

        <h2 style={sectionHeadingStyle}>1. Order Cancellation</h2>

        <p style={paragraphStyle}><strong>1.1 Cancellation of Standard Orders</strong></p>
        <p>• Customers may request the cancellation of an order within twenty-four (24) hours of placing the order or prior to the commencement of the roasting process, whichever occurs earlier, from the time of order placement by contacting our customer support at __________.</p>
        <p>• Any cancellation request received after the stipulated twenty-four (24) hours period may not be entertained, as the order may have already been processed for dispatch.</p>

        <p style={paragraphStyle}><strong>1.2 Cancellation of Pre-Orders or Bulk Orders</strong></p>
        <p>• Orders placed for bulk quantities or pre-orders may only be cancelled within twenty-four (24) hours of placing the order.</p>
        <p>• Cancellation requests beyond this period shall be subject to our discretion, considering factors such as inventory commitments and logistical arrangements.</p>
        <p>• If production or procurement has already commenced, a cancellation may not be permitted, or a restocking fee may be applicable, which shall be deducted from the refund amount.</p>

        <p style={paragraphStyle}><strong>1.3 Cancellation After Shipment</strong></p>
        <p>• Orders that have already been dispatched from our facility cannot be cancelled under any circumstances.</p>
        <p>• Customers may, however, choose to initiate a return request in accordance with our Return & Refund Policy.</p>

        <h2 style={sectionHeadingStyle}>2. Refunds on Cancelled Orders</h2>

        <p style={paragraphStyle}><strong>2.1 Eligibility for Refunds</strong></p>
        <p>• Orders successfully cancelled within the allowed timeframe shall be eligible for a full refund to the original payment method.</p>
        <p>• Refunds shall be processed within five (5) to seven (7) business days from the date of approval of the cancellation request.</p>

        <p style={paragraphStyle}><strong>2.2 Deductions & Processing Fees</strong></p>
        <p>• If a restocking fee or processing fee applies due to bulk order cancellation or special requests, the same shall be deducted from the refundable amount.</p>
        <p>• Refund timelines may vary based on the payment provider, and Magic Roast Qoffee shall not be liable for delays beyond our control.</p>

        <h2 style={sectionHeadingStyle}>3. Exceptional Circumstances</h2>
        <p>• The Company reserves the right to refuse a cancellation request in cases where the product has been customized, personalized, or processed for delivery.</p>
        <p>• In cases of force majeure, system failures, or unforeseen circumstances affecting order fulfilment, the Company may, at its sole discretion, approve a cancellation and issue an appropriate refund.</p>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default CancellationPolicy;
